/**
 * Used for DataGridPro detail panels
 *
 * This is defined as a standalone constant to have a stable reference.
 *
 * See https://mui.com/x/react-data-grid/master-detail/:
 * Always memoize the function provided to getDetailPanelContent and getDetailPanelHeight.
 * The Data Grid depends on the referential value of these props to cache their values and optimize the rendering.
 */
export const getDetailPanelHeight = () => 'auto' as const;
